import { useMemo } from 'react';
import { useSearchParams } from 'next/navigation';
import type { FormSettings } from '@mwl/core-lib';
import { requiredValidator } from '@mwl/core-lib';

import type { FormRegistrationSnValues } from './FormRegistrationSn.types';

export function useRegistrationSnFormSettings() {
  const searchParams = useSearchParams();
  const promocode = searchParams.get('promocode');

  return useMemo<FormSettings<FormRegistrationSnValues>>(
    () => ({
      currency: {
        rules: {
          required: { validate: requiredValidator, message: 'error' },
        },
        value: { label: '', value: '' },
      },
      promoCode: {
        value: promocode || '',
      },
      agree: {
        rules: {
          required: { validate: requiredValidator, message: 'error' },
        },
        value: true,
      },
    }),
    [promocode],
  );
}
